module.exports = function getKeyByValue(obj, id) {
  for (let i = 0; i < obj.length; i += 1) {
    if (obj[i].parent_id === id) return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/getKeyByValue.js